import { ADJUSTMENT_FIELDS, Entry, toNumber } from "../lib/entries";
import { DraftNumberInput } from "./DraftNumberInput";

export function AdjustmentsDisclosure({
  entry,
  onSaveField,
  disabled,
}: {
  entry: Entry;
  onSaveField: (entryId: string, field: string, raw: string) => void;
  disabled?: boolean;
}) {
  const activeCount = ADJUSTMENT_FIELDS.filter(
    ({ key }) => (toNumber(entry[key]) ?? 0) !== 0
  ).length;

  return (
    <details className="adjustments">
      <summary className="adjustments-summary">
        <span className="adjustments-toggle-label">Adjustments</span>
        {activeCount > 0 && (
          <span className="badge badge-warning">{activeCount} set</span>
        )}
      </summary>
      <div className="adjustments-grid">
        {ADJUSTMENT_FIELDS.map(({ key, label }) => (
          <label key={key} className="adjustments-field">
            <span>{label}</span>
            <DraftNumberInput
              value={entry[key]}
              onSave={(raw) => onSaveField(entry.id, key, raw)}
              className="numeric-input compact"
              disabled={disabled}
            />
          </label>
        ))}
      </div>
    </details>
  );
}
